import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'

import UserService from '../services/UserServices'
import EnquiryService from '../services/EnquiryServices'

const userService = new UserService()
const enquiryService = new EnquiryService()


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    modalVisible: false,
    modalContent: null,
    user: null,
    numberOfUnseenEnquiries: 0,
    favouriteTutors: []
  },
  getters: {
    user: state => {
      return state.user
    },
    isLoggedIn: state => {
      return localStorage.getItem('token') && !!state.user
    },
    favouriteTutors: state => {
      return state.favouriteTutors
    },
    isFavouriteTutor: state => tutorId => {
      return state.favouriteTutors.includes(tutorId)
    },
    hasViewedTestEnquiryEmail: state => {
      return state.user?.HasViewedTestEnquiryEmail
    },
    articles: state => {
      if (!state.user) return []
      return state.user.Articles.sort((a, b) => b.LastModifiedWhen.localeCompare(a.LastModifiedWhen)) 
    },
    progress: state => {
      return [
        { title: 'Add your name.', complete: !!state.user.Name },
        { title: 'Upload a profile photo.', complete: !!state.user.Photo },
        { title: 'Tell us where you reside.', complete: !!state.user.ResidenceCountry },
        { title: 'Introduce yourself in your bio.', complete: !!state.user.Bio },
        { title: 'Describe your approach to teaching.', complete: !!state.user.ApproachToTeaching },
        { title: 'Explain your previous teaching experience.', complete: !!state.user.TeachingExperience },
        { title: 'List the subjects you teach.', complete: !!state.user.SubjectsTaught.length > 0 },
        { title: 'Specify where you teach.', complete: state.user.Locations.length > 0 || state.user.TeachesOnline },
        { title: 'Provide information about the rate you charge.', complete: !!state.user.RateFrom },
        { title: 'Send and receive a test enquiry email.', complete: state.user.HasViewedTestEnquiryEmail },
        // { title: 'Write an article.', complete: this.user.Articles.filter(x => x.Status === 'PUBLISHED').length > 0 },
        { title: 'Complete an informal interview.', complete: state.user.HasPassedInterview },
      ]
    },
    canSubscribe: (_, getters) => getters.progress.every(x => x.complete)
  },
  mutations: {
    showModal(state, content) {
      state.modalContent = content
      state.modalVisible = true
    },
    hideModal(state) {
      state.modalVisible = false
    },
    setUser(state, user) {
      state.user = user
    },
    setNumberOfUnseenEnquiries(state, numberOfUnseenEnquiries) {
      state.numberOfUnseenEnquiries = numberOfUnseenEnquiries
    },
    setFavouriteTutors(state, payload) {
      state.favouriteTutors = payload
    }
  },
  actions: {
      // updateUserProfile({ state }, userProfile) {
      //     Object.assign(state.user, userProfile);  
      //     return this.dispatch('updateUser');
      // },
      updateUser({ state, commit }, fieldsToUpdate) {
        // Save to a new obj because we don't want to update state.user yet
        var data = Object.assign({}, state.user, fieldsToUpdate)
        
        // We don't want to save the photo every time
        var postData = Object.assign({}, data)
        delete postData.Photo

        return userService.saveUserDetails(postData).then(() => {
          commit('setUser', data)
        });  
      },
      updatePhoto({ state, commit }, photo) {
        return userService.saveUserPhoto(photo).then(() => {
          commit('setUser', Object.assign({}, state.user, photo))
        });  
      },
      getNumberOfUnseenEnquiries({ commit }) {
        return enquiryService.getNumberOfUnseenEnquiries().then(response => {
          commit('setNumberOfUnseenEnquiries', response.data)
        })
      },
      toggleTutorAsFavourite({ commit, getters }, tutorId) {
        let favouritedTutors = getters.favouriteTutors

        if (getters.isFavouriteTutor(tutorId)) {
          favouritedTutors.splice(favouritedTutors.indexOf(tutorId), 1)
        }
        else {
          favouritedTutors.push(tutorId)
        }

        Cookies.set(
          'favouriteTutors', 
          JSON.stringify(favouritedTutors), 
          { 
            expires: 365
          })

        commit('setFavouriteTutors', favouritedTutors)
      },
      loadFavouriteTutors({ commit }) {
        const favouritedTutors = Cookies.get('favouriteTutors')

        if (favouritedTutors)
          commit('setFavouriteTutors', JSON.parse(favouritedTutors))
      },
      async refreshUser({ commit }) {
        const response = await userService.getUserDetails()
        commit('setUser', response.data)
      },
  },
  modules: {
  }
})
